module.exports = __webpack_public_path__ + "static/media/ac.187f5add.png";